export default __webpack_public_path__ + "static/media/coinbag.0cec9465.png";